import React from 'react';
import SidebarPanel from './SidebarPanel';

const AgentDetailPanel = ({ agent, isOpen, onClose, onEdit }) => {
  if (!agent) return null;

  return (
    <SidebarPanel
      isOpen={isOpen}
      onClose={onClose}
      title="Agent Details"
      headerActions={
        <button className="btn btn-sm btn-primary" onClick={onEdit}>
          <i className="fa fa-pencil me-1"></i>
          Edit
        </button>
      }
    >
      <div className="p-3">
        <div className="card mb-3">
          <div className="card-header bg-light">
            <h6 className="mb-0">{agent.agent_name}</h6>
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <small className="text-muted d-block">Agent ID</small>
                <code className="d-block">{agent.agent_id}</code>
              </div>
              {agent.phone_number && (
                <div className="col-12">
                  <small className="text-muted d-block">Phone Number</small>
                  <strong>{agent.phone_number}</strong>
                </div>
              )}
              {agent.description && (
                <div className="col-12">
                  <small className="text-muted d-block">Description</small>
                  <p className="mb-0">{agent.description}</p>
                </div>
              )}
              {(agent.assigned_health_system_name || agent.assigned_organization_name) && (
                <div className="col-12">
                  <small className="text-muted d-block">Associated With</small>
                  <strong>
                    {agent.assigned_health_system_name && `Health System: ${agent.assigned_health_system_name}`}
                    {agent.assigned_organization_name && `Organization: ${agent.assigned_organization_name}`}
                  </strong>
                </div>
              )}
              <div className="col-6">
                <small className="text-muted d-block">Status</small>
                <span className={`badge bg-${agent.is_active ? 'success' : 'secondary'}`}>
                  {agent.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className="col-6">
                <small className="text-muted d-block">Created</small>
                <strong>{new Date(agent.created_at).toLocaleString()}</strong>
              </div>
            </div>
          </div>
        </div>

        {agent.retell_config && Object.keys(agent.retell_config).length > 0 && (
          <div className="card mb-3">
            <div className="card-header bg-light">
              <h6 className="mb-0">Retell Configuration</h6>
            </div>
            <div className="card-body">
              <pre className="mb-0" style={{ fontSize: '0.85em', maxHeight: '300px', overflow: 'auto' }}>
                {JSON.stringify(agent.retell_config, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </div>
    </SidebarPanel>
  );
};

export default AgentDetailPanel;
